module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/jameson.f29cce1b.svg";